/** Parses a media URL and only accepts http(s); returns null for any other scheme (e.g. javascript:, data:). */
export function parseHttpUrl(url) {
    try {
        const parsed = new URL(url, window.location.origin);
        return parsed.protocol === "http:" || parsed.protocol === "https:" ? parsed : null;
    }
    catch {
        return null;
    }
}
export function normalizedHost(parsed) {
    return parsed.hostname.toLowerCase().replace(/^www\./, "");
}
